var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnknown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4C16.4184 4 20 7.5824 20 12C20 16.4176 16.4184 20 12 20C7.5816 20 4 16.4176 4 12C4 7.5824 7.5816 4 12 4ZM12 5.3336C8.324 5.3336 5.3336 8.324 5.3336 12C5.3336 15.676 8.324 18.6664 12 18.6664C15.676 18.6664 18.6664 15.676 18.6664 12C18.6664 8.324 15.676 5.3336 12 5.3336ZM12 14.8C12.4418 14.8 12.8 15.1582 12.8 15.6C12.8 16.0418 12.4418 16.4 12 16.4C11.5582 16.4 11.2 16.0418 11.2 15.6C11.2 15.1582 11.5582 14.8 12 14.8ZM12 7.8C13.215 7.8 14.2 8.78498 14.2 10C14.2 10.8086 13.962 11.2592 13.3591 11.8869L13.2242 12.0242C12.7267 12.5218 12.6 12.733 12.6 13.2C12.6 13.5314 12.3314 13.8 12 13.8C11.6686 13.8 11.4 13.5314 11.4 13.2C11.4 12.3914 11.638 11.9408 12.2409 11.3131L12.3758 11.1758C12.8733 10.6782 13 10.467 13 10C13 9.44771 12.5523 9 12 9C11.4822 9 11.0564 9.3935 11.0052 9.89775L11 10C11 10.3314 10.7314 10.6 10.4 10.6C10.0686 10.6 9.8 10.3314 9.8 10C9.8 8.78498 10.785 7.8 12 7.8Z",
    fill: "#414548"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknown);
export default __webpack_public_path__ + "static/media/unknown.949ce2020315c2863de0e1714c1b2a9f.svg";
export { ForwardRef as ReactComponent };